import { FiBrowserEventsService } from '@fi-shared/fi-shared-services/fi-browser-events.service';
import { FiFormHelperService } from '@fi-app/shared/fi-form-shared/fi-form-helper.service';
import { ChangeDetectionStrategy, Component, ElementRef, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { FiFormQuestionBase } from '@fi-app/fi-form/fi-form-edit/fi-form-edit-form/fi-form-question-base';
import { FiComponentsContainer } from '@fi-shared/fi-components-container';

@Component({
    selector: 'fi-form-text-question',
    templateUrl: './fi-form-text-question.component.html',
    styleUrls: ['./fi-form-text-question.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-form-text-question' },
    providers: [{ provide: FiComponentsContainer, useExisting: FiFormTextQuestionComponent }],
    standalone: false,
})
export class FiFormTextQuestionComponent extends FiFormQuestionBase implements OnInit, OnDestroy {
    constructor(
        elementRef: ElementRef,
        formHelperService: FiFormHelperService,
        fiBrowserEventsService: FiBrowserEventsService,
    ) {
        super(fiBrowserEventsService, elementRef, formHelperService);
    }

    getElementIcon(): string {
        return this.fiFormHelperService.isTextQuestion(this.question) ? 'fas fa-keyboard' : 'fas fa-calculator';
    }
}
